import { Field, Form as FormikForm, Formik } from 'formik';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import React, { useState, useRef, useEffect } from 'react';
import StaticModal from '../modal/staticModal';
import './style.css';

type Props = {
  isCouponPopupDisplayed: boolean;
  isPanVerficationRequired?: boolean;
  couponList: any;
  onKYCPopupClose?: () => void;
  closeModal?: () => void;
  hideModal?: () => void;
  onCouponApply?: (data) => void;
  onResetCoupon?: () => void;
  childFunc: any;
};

const CouponModal = React.forwardRef(
  (
    {
      isCouponPopupDisplayed,
      isPanVerficationRequired,
      onKYCPopupClose,
      closeModal,
      hideModal,
      couponList,
      onCouponApply,
      childFunc,
    }: Props,
    ref: any 
  ) => {
    const [selectedCoupon, setSelectedCoupon] = useState('');
    const [inputCouponName, setInputCouponName] = useState('');
    const [appliedCoupons, setAppliedCoupons] = useState(null);

    const couponListData = couponList?.data?.data ?? [];

    const handleApplyCoupon = (index, value) => {
      setAppliedCoupons(index);
      setSelectedCoupon(value);
      onCouponApply(value?.name);
    };

    const onApplyCoupon = () => {
      onCouponApply(inputCouponName);
    };

    React.useEffect(() => {
      childFunc.current = onResetCoupon;
    }, []);

    const onResetCoupon = () => {
      setInputCouponName('');
      setAppliedCoupons(null);
      setSelectedCoupon('');
    };

    const handleChange = (e) => {
      if (e.target.value) {
        setInputCouponName(e.target.value.toUpperCase());
      } else {
        setInputCouponName('');
        setAppliedCoupons(null);
        setSelectedCoupon('');
      }
    };

    return (
      <>
        <StaticModal
          show={isCouponPopupDisplayed}
          handleClose={onKYCPopupClose}
          title='Select coupon'
          dialogClassName='coupon-modal-dialog'
          onClose={() => {
            hideModal(), onResetCoupon();
          }}
        >
          <Formik initialValues={{}} onSubmit={null}>
            {({}) => (
              <FormikForm>
                <div className='coupon-div'>
                  <InputGroup className='mb-3'>
                    <Form.Control
                      placeholder='Enter coupon code'
                      aria-label="Recipient's username"
                      aria-describedby='basic-addon2'
                      value={inputCouponName ? inputCouponName : ''}
                      onChange={(e) => handleChange(e)}
                    />
                    <button
                      className='btn btn-verify'
                      id='button-pan'
                      type='button'
                      onClick={() => onApplyCoupon()}
                      disabled={inputCouponName === '' ? true : false}
                    >
                      Apply coupon
                    </button>
                  </InputGroup>
                </div>
              </FormikForm>
            )}
          </Formik>

          <div className='available-coupon'>
            {couponListData?.length > 0 ? (
              couponListData?.map((value, index) => (
                <div key={index} className='coupon-container'>
                  <div className='coupon-left'>
                    <span className='vertical-text'>COUPON</span>
                  </div>
                  <div className='coupon-right'>
                    <h2>{value?.name}</h2>
                    <span>{value?.description}</span>
                    <div className='button-container'>
                      <button onClick={() => handleApplyCoupon(index, value)}>Apply</button>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div style={{ justifyContent: 'center', textAlign: 'center' }}>
                No coupons at this moment
              </div>
            )}
          </div>
        </StaticModal>
      </>
    );
  }
);

export default React.memo(CouponModal);